import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchEOModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchEOModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchEOModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchEOModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchEOModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
